import { useState } from 'react';
import { useForm } from 'react-hook-form';
import Icon from './Icon';
import { OptionProps } from './iInput';

export function OptionInput({
  input,
  name,
  register,
  value,
  min,
  max,
  disabled,
  placeholder,
  onFocus,
  onBlur,
  onChange,
  onClick,
  setValue,
  prefix,
  checked,
  inputName, // actual name
}: OptionProps) {
  let hookRegister = register!;
  const [refLoaded, setRefLoaded] = useState(false);
  if (!register) {
    const {
      register: tReg,
      // eslint-disable-next-line react-hooks/rules-of-hooks
    } = useForm({
      mode: 'all',
      defaultValues: {
        [name]: value,
      },
    });
    hookRegister = tReg;
  }
  const hookProps = hookRegister(name.split('_')[0]);
  // console.log('radio?', name, hookProps);
  // let inputRef : HTMLInputElement | null = null;
  // console.log('hookProps', name, hookProps);
  // console.log('input', name, {prefix});
  switch (input) {
    case 'checkbox':
      return (
        <>
          <Icon
            name="exclamation-mark"
            color="danger"
            className="error-icon absolute right-2 top-4"
          />
          <input
            className={`rounded-md mt-0.5 w-full ${prefix ? ' pl-0' : ''}`}
            type={input}
            id={name}
            {...hookProps}
            onFocus={onFocus}
            onBlur={(e) => [hookProps.onBlur(e), onBlur ? onBlur(e) : null]}
            onChange={(e) => {
              // console.log('checkbox change', e.target);
              setValue(name, e.target.value, { shouldValidate: true });
              hookProps.onChange(e);
              if (onChange) {
                onChange(e);
              }
            }}
            min={min}
            max={max}
            defaultValue={value}
            placeholder={placeholder}
            disabled={disabled}
            ref={(r) => {
              hookProps.ref(r);
              if (r && !refLoaded && onChange) {
                setRefLoaded(true);
                // console.log('ref call!!!', name, refLoaded);
                // console.log('rrr', r);
                onChange(r.checked);
              }
            }}
          />
        </>
      );
      break;

    case 'radio':
      return (
        <input
          disabled={disabled}
          type={input}
          id={name}
          className="input cursor-not-allowed"
          {...hookProps}
          checked={checked}
          onFocus={onFocus}
          onClick={(e) => {
            setValue(inputName, { shouldValidate: true });
            if (onClick) {
              onClick(e);
            }
          }}
          onBlur={(e) => [hookProps.onBlur(e), onBlur ? onBlur(e) : null]}
          onChange={(e) => {
            // console.log('radio change', e.target);
            setValue(inputName, e.target.value, { shouldValidate: true });
            hookProps.onChange(e);
            if (onChange) {
              onChange(e);
            }
          }}
          value={value}
          ref={(r) => {
            hookProps.ref(r);
            if (r && !refLoaded && onChange) {
              // console.log('rrr', r);
              onChange(r.value);
              setRefLoaded(true);
            }
          }}
          // TODO checked
        />
      );
    default:
      throw new Error(`Invalid option input: ${input}`);
  }
}
